(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("zarm"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "zarm"], factory);
	else if(typeof exports === 'object')
		exports["Gs"] = factory(require("react"), require("react-dom"), require("zarm"));
	else
		root["Gs"] = factory(root["react"], root["react-dom"], root["zarm"]);
})(global, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__, __WEBPACK_EXTERNAL_MODULE_zarm__) {
return 